import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "row mt-3 mb-3" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "row mt-3 mb-3" }
const _hoisted_4 = { class: "col-md-2" }
const _hoisted_5 = { class: "col-md-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Utgåva", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Status", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "row mt-3 mb-3" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "row mt-3 mb-3" }
const _hoisted_14 = { class: "col-md-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Kommentarer", -1)
const _hoisted_16 = { class: "row mt-3 mb-3" }
const _hoisted_17 = { class: "col-md-5" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_field_errors = _resolveComponent("field-errors")!
  const _component_number_field = _resolveComponent("number-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.isNew ? "Skapa nytt innehåll" : "Ändra innehåll"), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_field, {
          label: "Titel",
          modelValue: _ctx.state.form.title,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.form.title) = $event)),
          onInput: _ctx.validate
        }, null, 8, ["modelValue", "onInput"]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "title"
        }, null, 8, ["errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_number_field, {
          label: "Storlek",
          modelValue: _ctx.state.form.contentSize,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.form.contentSize) = $event)),
          modelModifiers: { number: true },
          onInput: _ctx.validate
        }, null, 8, ["modelValue", "onInput"]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "contentSize"
        }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("select", {
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.form.editionId) = $event)),
          class: "form-select form-select-sm"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.editions, (edition, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: edition.editionId
            }, _toDisplayString(edition.editionName), 9, _hoisted_7))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.state.form.editionId]
        ]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "editionId"
        }, null, 8, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("select", {
          onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.form.status) = $event)),
          class: "form-select form-select-sm"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.statuses, (status, index) => {
            return (_openBlock(), _createElementBlock("option", {
              key: index,
              value: status.value
            }, _toDisplayString(status.display), 9, _hoisted_10))
          }), 128))
        ], 544), [
          [
            _vModelSelect,
            _ctx.state.form.status,
            void 0,
            { number: true }
          ]
        ]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "status"
        }, null, 8, ["errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_text_field, {
          onInput: _ctx.validate,
          label: "Ansvarig",
          modelValue: _ctx.state.form.responsible,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.form.responsible) = $event))
        }, null, 8, ["onInput", "modelValue"]),
        _createVNode(_component_field_errors, {
          errors: _ctx.state.errors,
          single: "true",
          field: "responsible"
        }, null, 8, ["errors"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("textarea", {
          onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
          rows: "4",
          class: "form-control form-control-sm",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.form.comments) = $event))
        }, "\n      ", 544), [
          [_vModelText, _ctx.state.form.comments]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary me-1 btn-sm",
          disabled: _ctx.hasErrors,
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, _toDisplayString(_ctx.isNew ? "Skapa" : "Spara"), 9, _hoisted_18),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary btn-sm",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, " Avbryt ")
      ])
    ])
  ], 64))
}